"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thorTradeApprovalNeeded = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const api_1 = require("../../../api");
const erc20Allowance_abi_1 = require("../../utils/abi/erc20Allowance-abi");
const bignumber_1 = require("../../utils/bignumber");
const helpers_1 = require("../../utils/helpers/helpers");
const thorTradeApprovalNeeded = async ({ deps, input, }) => {
    var _a;
    try {
        const { quote, wallet } = input;
        const { sellAsset, bip44Params } = quote;
        const { adapterManager, web3 } = deps;
        const { assetReference: sellAssetErc20Address } = (0, caip_1.fromAssetId)(sellAsset.assetId);
        const { chainNamespace } = (0, caip_1.fromChainId)(sellAsset.chainId);
        if (chainNamespace !== caip_1.CHAIN_NAMESPACE.Evm)
            return { approvalNeeded: false };
        const adapter = adapterManager.get(sellAsset.chainId);
        if (!adapter)
            throw new api_1.SwapError(`[thorTradeApprovalNeeded] - no chain adapter found for chain Id: ${sellAsset.chainId}`, {
                code: api_1.SwapErrorTypes.UNSUPPORTED_CHAIN,
                details: { chainId: sellAsset.chainId },
            });
        // No approval needed for selling a fee asset
        if (sellAsset.assetId === adapter.getFeeAssetId()) {
            return { approvalNeeded: false };
        }
        const receiveAddress = await adapter.getAddress({ wallet, bip44Params });
        if (!quote.allowanceContract) {
            throw new api_1.SwapError('[thorTradeApprovalNeeded] - allowanceTarget is required', {
                code: api_1.SwapErrorTypes.VALIDATION_FAILED,
                details: { chainId: sellAsset.chainId },
            });
        }
        const allowanceResult = await (0, helpers_1.getERC20Allowance)({
            web3,
            erc20AllowanceAbi: erc20Allowance_abi_1.erc20AllowanceAbi,
            sellAssetErc20Address,
            spenderAddress: quote.allowanceContract,
            ownerAddress: receiveAddress,
        });
        const allowanceOnChain = (0, bignumber_1.bnOrZero)(allowanceResult);
        if (!((_a = quote.feeData.chainSpecific) === null || _a === void 0 ? void 0 : _a.gasPriceCryptoBaseUnit))
            throw new api_1.SwapError('[thorTradeApprovalNeeded] - no gas price with quote', {
                code: api_1.SwapErrorTypes.RESPONSE_ERROR,
                details: { feeData: quote.feeData },
            });
        return {
            approvalNeeded: allowanceOnChain.lt((0, bignumber_1.bnOrZero)(quote.sellAmountBeforeFeesCryptoBaseUnit)),
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[thorTradeApprovalNeeded]', {
            cause: e,
            code: api_1.SwapErrorTypes.CHECK_APPROVAL_FAILED,
        });
    }
};
exports.thorTradeApprovalNeeded = thorTradeApprovalNeeded;
